exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".pr0 .yxt-drawer__body{padding-right:0 !important}\n", ""]);

